import { Query } from 'cogent-js';
import BaseApiService from './base';

export default class FlawedTraysApiService extends BaseApiService {
  constructor() {
    super();
    this.query = new Query();
  }

  get({
    perPage = 5,
    page = 1,
    order,
    orderBy,
    userId,
    searchFullNameQuery = '',
    includes = [],
    searchDoctorFullNameQuery = '',
    statusId = '',
    organizationId = '',
    organizations = []
  }) {
    const orderChar = order === 'desc' ? '-' : '+';
    const orderByField = orderBy || 'id';
    return this.request({
      method: 'get',
      url: this.query
        .for('flawed_trays')
        .include(...includes)
        .where('arch.patient.user_id', userId)
        .where('patient_full_name_like', searchFullNameQuery)
        .where('doctor_full_name_like', searchDoctorFullNameQuery)
        .where('status_id', statusId)
        .where('only_with_patient', true)
        .where('organization_id', organizationId)
        .whereIn('chosen_wi_organization_id', organizations)
        .sort(orderChar + orderByField)
        .params({ perPage, page })
        .get()
    });
  }

  show(id) {
    return this.request({
      method: 'get',
      url: `/flawed_trays/${id}`
    });
  }

  correctFlawedTray(id, fileId) {
    return this.request({
      method: 'post',
      url: `/flawed_trays/${id}/corrected`,
      data: {
        corrected_file_id: fileId
      }
    });
  }

  update(id, data) {
    return this.request({
      method: 'put',
      url: `/flawed_trays/${id}`,
      data
    });
  }

  remove(id) {
    return this.request({
      method: 'delete',
      url: `/flawed_trays/${id}`
    });
  }

  requestForCorrection(organizationId, data) {
    return this.request({
      method: 'post',
      url: `/organizations/${organizationId}/arch`,
      data
    });
  }
}
